import { Regions, States } from '@/components/Map/types'
import {
  Region,
  State,
  Dependency,
  Location,
  EducationStage,
  Sphere,
  RegionLabelValue,
  StateLabelValue,
  DependencyLabelValue,
  LocationLabelValue,
  EducationStageLabelValue,
  SphereLabelValue,
} from '@/types/dashboard'

export const regionOptions: RegionLabelValue[] = [
  { label: 'Norte', value: Region.NORTH },
  { label: 'Nordeste', value: Region.NORTHEAST },
  { label: 'Sudeste', value: Region.SOUTHEAST },
  { label: 'Sul', value: Region.SOUTH },
  { label: 'Centro-Oeste', value: Region.MIDWEST },
]

export const dependencyOptions: DependencyLabelValue[] = [
  { label: 'Federal', value: Dependency.FEDERAL },
  { label: 'Estadual', value: Dependency.STATE },
  { label: 'Municipal', value: Dependency.MUNICIPAL },
  { label: 'Privada', value: Dependency.PRIVATE },
]

export const locationOptions: LocationLabelValue[] = [
  { label: 'Urbana', value: Location.URBAN },
  { label: 'Rural', value: Location.RURAL },
]

export const educationStageOptions: EducationStageLabelValue[] = [
  { label: 'Curso Técnico', value: EducationStage.TECHNICAL_COURSE },
  {
    label: 'Educação de Jovens e Adultos',
    value: EducationStage.YOUTH_AND_ADULT_EDUCATION,
  },
  {
    label: 'Educação Infantil',
    value: EducationStage.EARLY_CHILDHOOD_EDUCATION,
  },
  {
    label: 'Ensino Fundamental - Anos Iniciais',
    value: EducationStage.ELEMENTARY_SCHOOL_EARLY_YEARS,
  },
  {
    label: 'Ensino Fundamental - Anos Finais',
    value: EducationStage.ELEMENTARY_SCHOOL_FINAL_YEARS,
  },
  { label: 'Ensino Médio', value: EducationStage.HIGH_SCHOOL },
]

export const sphereOptions: SphereLabelValue[] = [
  { label: 'Pública', value: Sphere.PUBLIC },
  { label: 'Privada', value: Sphere.PRIVATE_CONVENIADA },
  {
    label: 'Privada',
    value: Sphere.PRIVATE_NAO_CONVENIADA,
  },
]

export const stateOptions: StateLabelValue[] = [
  { label: 'Acre', value: State.AC },
  { label: 'Alagoas', value: State.AL },
  { label: 'Amapá', value: State.AP },
  { label: 'Amazonas', value: State.AM },
  { label: 'Bahia', value: State.BA },
  { label: 'Ceará', value: State.CE },
  { label: 'Distrito Federal', value: State.DF },
  { label: 'Espírito Santo', value: State.ES },
  { label: 'Goiás', value: State.GO },
  { label: 'Maranhão', value: State.MA },
  { label: 'Mato Grosso', value: State.MT },
  { label: 'Mato Grosso do Sul', value: State.MS },
  { label: 'Minas Gerais', value: State.MG },
  { label: 'Pará', value: State.PA },
  { label: 'Paraíba', value: State.PB },
  { label: 'Paraná', value: State.PR },
  { label: 'Pernambuco', value: State.PE },
  { label: 'Piauí', value: State.PI },
  { label: 'Rio de Janeiro', value: State.RJ },
  { label: 'Rio Grande do Norte', value: State.RN },
  { label: 'Rio Grande do Sul', value: State.RS },
  { label: 'Rondônia', value: State.RO },
  { label: 'Roraima', value: State.RR },
  { label: 'Santa Catarina', value: State.SC },
  { label: 'São Paulo', value: State.SP },
  { label: 'Sergipe', value: State.SE },
  { label: 'Tocantins', value: State.TO },
]

export const stateToRegionMap: Record<State, Region> = {
  [State.AC]: Region.NORTH,
  [State.AL]: Region.NORTHEAST,
  [State.AP]: Region.NORTH,
  [State.AM]: Region.NORTH,
  [State.BA]: Region.NORTHEAST,
  [State.CE]: Region.NORTHEAST,
  [State.DF]: Region.MIDWEST,
  [State.ES]: Region.SOUTHEAST,
  [State.GO]: Region.MIDWEST,
  [State.MA]: Region.NORTHEAST,
  [State.MT]: Region.MIDWEST,
  [State.MS]: Region.MIDWEST,
  [State.MG]: Region.SOUTHEAST,
  [State.PA]: Region.NORTH,
  [State.PB]: Region.NORTHEAST,
  [State.PR]: Region.SOUTH,
  [State.PE]: Region.NORTHEAST,
  [State.PI]: Region.NORTHEAST,
  [State.RJ]: Region.SOUTHEAST,
  [State.RN]: Region.NORTHEAST,
  [State.RS]: Region.SOUTH,
  [State.RO]: Region.NORTH,
  [State.RR]: Region.NORTH,
  [State.SC]: Region.SOUTH,
  [State.SP]: Region.SOUTHEAST,
  [State.SE]: Region.NORTHEAST,
  [State.TO]: Region.NORTH,
}

export const regionEnumToStringMap: Record<Region, Regions> = {
  [Region.NORTH]: 'Norte',
  [Region.NORTHEAST]: 'Nordeste',
  [Region.SOUTHEAST]: 'Sudeste',
  [Region.SOUTH]: 'Sul',
  [Region.MIDWEST]: 'Centro-Oeste',
}

export const stateEnumToSiglaMap: Record<State, States> = {
  [State.AC]: 'AC',
  [State.AL]: 'AL',
  [State.AP]: 'AP',
  [State.AM]: 'AM',
  [State.BA]: 'BA',
  [State.CE]: 'CE',
  [State.DF]: 'DF',
  [State.ES]: 'ES',
  [State.GO]: 'GO',
  [State.MA]: 'MA',
  [State.MT]: 'MT',
  [State.MS]: 'MS',
  [State.MG]: 'MG',
  [State.PA]: 'PA',
  [State.PB]: 'PB',
  [State.PR]: 'PR',
  [State.PE]: 'PE',
  [State.PI]: 'PI',
  [State.RJ]: 'RJ',
  [State.RN]: 'RN',
  [State.RS]: 'RS',
  [State.RO]: 'RO',
  [State.RR]: 'RR',
  [State.SC]: 'SC',
  [State.SP]: 'SP',
  [State.SE]: 'SE',
  [State.TO]: 'TO',
}
